
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    mandatory: {
      type: Boolean,
      default: false
    }
  }
};
